
 import React from "react"; 
 import { AiOutlinePlus } from 'react-icons/ai'; 
 import { HiOutlineViewList } from 'react-icons/hi'; 
 import './style.css'; 
 let Dashboard=(props)=> { 
   return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc1">
        <h3 style={{padding:10,textAlign: 'center'}}>
  
  Dashboard
  
  </h3>
        <br></br>
        <button className="button" onClick={()=>props.history.push('/evalution')} id='createNew'> Create New
          <AiOutlinePlus />
        </button>
        <table id='tableAll'>
          <thead>
            <tr>
              <th scope="col">Sr No.</th>
              <th scope="col">Intiative</th>
              <th scope="col">ScoreCard
                <br></br>Name</th>
              <th scope="col">Version</th>
              <th scope="col">Opportunity
                <br></br>Score</th>
              <th scope="col">Execution
                <br></br>Score</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Sr No.">1</td>
              <td data-label="Intiative">POS Replacment</td>
              <td data-label="ScoreCard Name">First/Pass W/o Resarch</td>
              <td data-label="Version">1</td>
              <td data-label="Opportunity Score">50</td>
              <td data-label="Execution Score">30</td>
              <td>
                <div id="centerW">
                  <button id="deleteButt">Edit</button>
                  <button id="deleteButt">Duplicate</button>
                </div>
              </td>
              <td>
                <div id="centerW">
                  <button id="deleteButt">Download</button>
                  <button id="deleteButt">Delete</button>
                </div>
              </td>
            </tr>
            <tr>
              <td data-label="Sr No.">2</td>
              <td data-label="Intiative">ROS Replacment</td>
              <td data-label="ScoreCard Name">First/Pass W/o Resarch</td>
              <td data-label="Version">1</td>
              <td data-label="Opportunity Score">30</td>
              <td data-label="Execution Score">90</td>
              <td>
                <div id="centerW">
                  <button id="deleteButt">Edit</button>
                  <button id="deleteButt">Duplicate</button>
                </div>
              </td>
              <td>
                <div id="centerW">
                  <button id="deleteButt">Download</button>
                  <button id="deleteButt">Delete</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>) } 
  export default Dashboard;